import { generatePath } from 'react-router'

import { formatDateValue } from '~/models/dateTime'
import { routePaths } from '~/routes/routePaths'

/** 取引先カードの遷移先に渡す不整合範囲 (AC-PSM-038-1、Slice 6 で供給する)。 */
export type PlanDetailMismatch = {
  from: string
  to: string
  partnerCode: string
  side: 'procurement' | 'sales'
}

/**
 * 取引先カード → 需要調達計画詳細の遷移 URL (AC-PSM-038 / 038-1)。
 * mismatch なしはクエリなし、ありは highlightFrom / highlightTo / partner / side を付ける。
 */
export function buildPlanDetailUrl(
  planSubmissionId: string,
  mismatch?: PlanDetailMismatch,
): string {
  const path = generatePath(routePaths.planProcurementDetail.path, {
    id: planSubmissionId,
  })
  if (mismatch === undefined) return path
  return `${path}?${highlightQuery(mismatch).toString()}`
}

function highlightQuery(mismatch: PlanDetailMismatch): URLSearchParams {
  return new URLSearchParams({
    highlightFrom: mismatch.from,
    highlightTo: mismatch.to,
    partner: mismatch.partnerCode,
    side: mismatch.side,
  })
}

/**
 * 取引先カード → eBalance に提出記録の無い計画の詳細の遷移 URL (AC-PSM-038 /
 * 038-1 → AC-PPD-028)。版の ID が無いので計画を業務キー (対象日・計画提出者コード) で
 * 指す。計画種別は route が需要調達計画に固定し、エリアは提出者コードの末桁で決まる。
 * mismatch ありはハイライトのクエリを続けて付ける。受け側の契約は
 * `ProcurementPlanDetail/models/noSubmissionRecordPlanQuery.ts`。
 */
export function buildNoSubmissionRecordPlanUrl(
  targetDate: Date,
  submissionEntityCode: string,
  mismatch?: PlanDetailMismatch,
): string {
  const query = new URLSearchParams({
    targetDate: formatDateValue(targetDate),
    submissionEntityCode,
  })
  if (mismatch !== undefined) {
    for (const [key, value] of highlightQuery(mismatch)) {
      query.set(key, value)
    }
  }
  return `${routePaths.planProcurementNoSubmissionRecord.path}?${query.toString()}`
}
